<app-auth-navbar></app-auth-navbar>
<main class="rtl">
    <div class="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
        <div class="absolute top-0 w-full h-full bg-center bg-cover">
            <span class="bg-primary w-full h-full absolute" id="blackOverlay"></span>
        </div>
        <div class="container relative mx-auto">
            <div class="items-center flex flex-wrap">
                <div class="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                    <div class="">
                        <h1 class="text-white font-semibold text-5xl leading-normal">
                            استاد ویزیت، سامانه ویزیت و مشاوره آنلاین پزشکی
                        </h1>
                        <div class="relative flex w-full flex-wrap items-stretch mt-12"><span
                                class="z-10 h-full leading-snug font-normal text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3"><i
                                    class="fa fa-search"></i></span><input type="text"
                                placeholder=" نام پزشک، نام بیماری، تخصص ... "
                                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded shadow  w-full pl-10">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="pt-32 py-16 main-bg">
        <div class="container mx-auto px-4">
            <div class="flex flex-wrap p-4">
                <div class="w-full lg:w-6/12 px-4 bg-white rounded p-4 shadow-lg">
                    <div class="relative flex break-words">
                        <span>
                            مرتب سازی:
                        </span>
                        <span class="px-4">
                            پیش فرض
                        </span>
                        <span class="px-4">
                            محبوب ترین
                        </span>
                        <span class="px-4">
                            بیشترین تجربه
                        </span>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap">
                <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
                    <div class="bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
                        <div class="relative flex break-words">
                            <img alt="..." src="assets/img/team-1-800x800.jpg" class="shadow-lg rounded-full w-20 h-20 mt-3" />
                            <div class="p-4">
                                <h5 class="text-xl font-bold"> دکتر سمیرا زارع فر </h5>
                                <p class="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                                    متخصص بیماری های عفونی
                                </p>
                                <div class="flex items-center mt-2">
                                    <svg class="w-5 h-5 mx-1 text-yellow-300 me-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                                    </svg>
                                    <p class="me-2 text-base font-bold text-gray-800 ">5</p>
                                    <a href="#" class="text-sm font-medium text-gray-800 mx-2">73 نظر</a>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="mt-4">
                            <p class="text-base"> خدمات: </p>
                        </div>
                        <div class="flex mt-2">
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/video-call.svg" alt=""  width="20px"> <span> مشاوره تصویری </span></p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/voice-call.svg" alt="" width="16px"> مشاوره تلفنی </p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/message.svg" alt="" width="22px"> مشاوره متنی </p>
                        </div>
                        <div class="mt-6 flex justify-end">
                            <button class="bg-primary text-white w-1/2 h-8 rounded outline-none focus:outline-none mb-1"
                                type="button"> دریافت نوبت
                            </button>
                        </div>
                    </div>
                </div>
                <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
                    <div class="bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
                        <div class="relative flex break-words">
                            <img alt="..." src="assets/img/team-1-800x800.jpg" class="shadow-lg rounded-full w-20 h-20 mt-3" />
                            <div class="p-4">
                                <h5 class="text-xl font-bold"> دکتر سمیرا زارع فر </h5>
                                <p class="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                                    متخصص بیماری های عفونی
                                </p>
                                <div class="flex items-center mt-2">
                                    <svg class="w-5 h-5 mx-1 text-yellow-300 me-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                                    </svg>
                                    <p class="me-2 text-base font-bold text-gray-800 ">5</p>
                                    <a href="#" class="text-sm font-medium text-gray-800 mx-2">73 نظر</a>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="mt-4">
                            <p class="text-base"> خدمات: </p>
                        </div>
                        <div class="flex mt-2">
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/video-call.svg" alt=""  width="20px"> <span> مشاوره تصویری </span></p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/voice-call.svg" alt="" width="16px"> مشاوره تلفنی </p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/message.svg" alt="" width="22px"> مشاوره متنی </p>
                        </div>
                        <div class="mt-6 flex justify-end">
                            <button class="bg-primary text-white w-1/2 h-8 rounded outline-none focus:outline-none mb-1"
                                type="button"> دریافت نوبت
                            </button>
                        </div>
                    </div>
                </div>
                <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
                    <div class="bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
                        <div class="relative flex break-words">
                            <img alt="..." src="assets/img/team-1-800x800.jpg" class="shadow-lg rounded-full w-20 h-20 mt-3" />
                            <div class="p-4">
                                <h5 class="text-xl font-bold"> دکتر سمیرا زارع فر </h5>
                                <p class="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                                    متخصص بیماری های عفونی
                                </p>
                                <div class="flex items-center mt-2">
                                    <svg class="w-5 h-5 mx-1 text-yellow-300 me-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                                    </svg>
                                    <p class="me-2 text-base font-bold text-gray-800 ">5</p>
                                    <a href="#" class="text-sm font-medium text-gray-800 mx-2">73 نظر</a>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="mt-4">
                            <p class="text-base"> خدمات: </p>
                        </div>
                        <div class="flex mt-2">
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/video-call.svg" alt=""  width="20px"> <span> مشاوره تصویری </span></p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/voice-call.svg" alt="" width="16px"> مشاوره تلفنی </p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/message.svg" alt="" width="22px"> مشاوره متنی </p>
                        </div>
                        <div class="mt-6 flex justify-end">
                            <button class="bg-primary text-white w-1/2 h-8 rounded outline-none focus:outline-none mb-1"
                                type="button"> دریافت نوبت
                            </button>
                        </div>
                    </div>
                </div>
                <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
                    <div class="bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
                        <div class="relative flex break-words">
                            <img alt="..." src="assets/img/team-1-800x800.jpg" class="shadow-lg rounded-full w-20 h-20 mt-3" />
                            <div class="p-4">
                                <h5 class="text-xl font-bold"> دکتر سمیرا زارع فر </h5>
                                <p class="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                                    متخصص بیماری های عفونی
                                </p>
                                <div class="flex items-center mt-2">
                                    <svg class="w-5 h-5 mx-1 text-yellow-300 me-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                                    </svg>
                                    <p class="me-2 text-base font-bold text-gray-800 ">5</p>
                                    <a href="#" class="text-sm font-medium text-gray-800 mx-2">73 نظر</a>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="mt-4">
                            <p class="text-base"> خدمات: </p>
                        </div>
                        <div class="flex mt-2">
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/video-call.svg" alt=""  width="20px"> <span> مشاوره تصویری </span></p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/voice-call.svg" alt="" width="16px"> مشاوره تلفنی </p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/message.svg" alt="" width="22px"> مشاوره متنی </p>
                        </div>
                        <div class="mt-6 flex justify-end">
                            <button class="bg-primary text-white w-1/2 h-8 rounded outline-none focus:outline-none mb-1"
                                type="button"> دریافت نوبت
                            </button>
                        </div>
                    </div>
                </div>
                <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
                    <div class="bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
                        <div class="relative flex break-words">
                            <img alt="..." src="assets/img/team-1-800x800.jpg" class="shadow-lg rounded-full w-20 h-20 mt-3" />
                            <div class="p-4">
                                <h5 class="text-xl font-bold"> دکتر سمیرا زارع فر </h5>
                                <p class="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                                    متخصص بیماری های عفونی
                                </p>
                                <div class="flex items-center mt-2">
                                    <svg class="w-5 h-5 mx-1 text-yellow-300 me-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                                    </svg>
                                    <p class="me-2 text-base font-bold text-gray-800 ">5</p>
                                    <a href="#" class="text-sm font-medium text-gray-800 mx-2">73 نظر</a>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="mt-4">
                            <p class="text-base"> خدمات: </p>
                        </div>
                        <div class="flex mt-2">
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/video-call.svg" alt=""  width="20px"> <span> مشاوره تصویری </span></p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/voice-call.svg" alt="" width="16px"> مشاوره تلفنی </p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/message.svg" alt="" width="22px"> مشاوره متنی </p>
                        </div>
                        <div class="mt-6 flex justify-end">
                            <button class="bg-primary text-white w-1/2 h-8 rounded outline-none focus:outline-none mb-1"
                                type="button"> دریافت نوبت
                            </button>
                        </div>
                    </div>
                </div>
                <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
                    <div class="bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
                        <div class="relative flex break-words">
                            <img alt="..." src="assets/img/team-1-800x800.jpg" class="shadow-lg rounded-full w-20 h-20 mt-3" />
                            <div class="p-4">
                                <h5 class="text-xl font-bold"> دکتر سمیرا زارع فر </h5>
                                <p class="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                                    متخصص بیماری های عفونی
                                </p>
                                <div class="flex items-center mt-2">
                                    <svg class="w-5 h-5 mx-1 text-yellow-300 me-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                                    </svg>
                                    <p class="me-2 text-base font-bold text-gray-800 ">5</p>
                                    <a href="#" class="text-sm font-medium text-gray-800 mx-2">73 نظر</a>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="mt-4">
                            <p class="text-base"> خدمات: </p>
                        </div>
                        <div class="flex mt-2">
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/video-call.svg" alt=""  width="20px"> <span> مشاوره تصویری </span></p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/voice-call.svg" alt="" width="16px"> مشاوره تلفنی </p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/message.svg" alt="" width="22px"> مشاوره متنی </p>
                        </div>
                        <div class="mt-6 flex justify-end">
                            <button class="bg-primary text-white w-1/2 h-8 rounded outline-none focus:outline-none mb-1"
                                type="button"> دریافت نوبت
                            </button>
                        </div>
                    </div>
                </div>
                <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
                    <div class="bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
                        <div class="relative flex break-words">
                            <img alt="..." src="assets/img/team-1-800x800.jpg" class="shadow-lg rounded-full w-20 h-20 mt-3" />
                            <div class="p-4">
                                <h5 class="text-xl font-bold"> دکتر سمیرا زارع فر </h5>
                                <p class="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                                    متخصص بیماری های عفونی
                                </p>
                                <div class="flex items-center mt-2">
                                    <svg class="w-5 h-5 mx-1 text-yellow-300 me-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                                    </svg>
                                    <p class="me-2 text-base font-bold text-gray-800 ">5</p>
                                    <a href="#" class="text-sm font-medium text-gray-800 mx-2">73 نظر</a>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="mt-4">
                            <p class="text-base"> خدمات: </p>
                        </div>
                        <div class="flex mt-2">
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/video-call.svg" alt=""  width="20px"> <span> مشاوره تصویری </span></p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/voice-call.svg" alt="" width="16px"> مشاوره تلفنی </p>
                            <p class="text-sm flex px-2"> <img src="../../../../assets/img/icon/message.svg" alt="" width="22px"> مشاوره متنی </p>
                        </div>
                        <div class="mt-6 flex justify-end">
                            <button class="bg-primary text-white w-1/2 h-8 rounded outline-none focus:outline-none mb-1"
                                type="button"> دریافت نوبت
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>


</main>
<app-footer></app-footer>